import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-privacy-policy-india',
    templateUrl: './privacy-policy-india.component.html',
    styleUrls: ['./privacy-policy-india.component.css'],
})
export class PrivacyPolicyIndiaComponent implements OnInit {
    constructor(public dialogRef: MatDialogRef<PrivacyPolicyIndiaComponent>) {}

    ngOnInit(): void {}

    close() {
        this.dialogRef.close();
    }
}
